<template>
    <div>  
      <button @click="toggleLanguage" class="language-toggle-button">
        {{ $i18n.locale === 'nl' ? 'EN' : 'NL' }}
      </button>
      <Home />
      <Menu />
      <Practical />
      <Book />
      <Footer />
    </div>
  </template>
  
  <script>
  import Home from '@/views/Home.vue';
  import Book from '@/views/Book.vue';
  import Menu from '@/views/Menu.vue';
  import Practical from '@/views/Practical.vue';
  import Footer from '@/components/Footer.vue';

  export default {
    components: { Home, Menu, Practical, Book, Footer },
    methods: {
      stopEvent(event) {
        event.stopPropagation();
        event.preventDefault();
      },
      toggleLanguage() {
        const targetLang = this.$i18n.locale === 'nl' ? 'en' : 'nl';
        this.$i18n.locale = targetLang;

        const currentPath = this.$router.currentRoute.path;
        const pathParts = currentPath.split('/');

        if (pathParts[1] === 'en' || pathParts[1] === 'nl') {
          if (pathParts.length <= 2 || (pathParts.length === 3 && pathParts[2] === '')) {
            this.$router.push({ path: `/${targetLang}` });
          } else {
            pathParts[1] = targetLang;
            this.$router.push({ path: pathParts.join('/').replace(/\/\//g, '/') });
          }
        } else {
          if (this.$router.currentRoute.name) {
            if (currentPath === '/') {
              this.$router.push({ path: `/${targetLang}` });
            } else {
              let newPath = `/${targetLang}${currentPath.startsWith('/') ? '' : '/'}${currentPath}`;
              newPath = newPath.replace(/\/\//g, '/');
              this.$router.push({ path: newPath });
            }
          } else {
            this.$router.push({ path: `/${targetLang}${currentPath.replace(/\/\//g, '/')}` });
          }
        }
      }
    }
  };
  </script>
  
  <style>
  html {
    scroll-behavior: smooth;
  }
  
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 3s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  
  /* .hide-cadeaubon should always be on top of the iframe, be 100px wide and 100px high and be red
  */
  
  .hide-cadeaubon {
    z-index: 2147483647; /* Max z-index value */
    color: rgba(168,160,89,1) ;
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 124px;
    height: 29px;
    background-color: rgba(168,160,89,1);
    /* pointer-events: none; Removed to allow click capture */
  }

  .language-toggle-button {
    position: fixed; /* Or absolute, depending on desired behavior */
    top: 20px;
    left: 20px; /* Changed from right to left */
    padding: 4px 8px; /* Reduced padding */
    background-color: #333;
    color: white;
    border: none;
    cursor: pointer;
    z-index: 2147483647; /* Ensure it's on top */
  }

  .language-toggle-button:hover {
    background-color: #555;
  }
  </style>
  